import debounce from 'lodash/debounce';
import { SET_ERROR_STATE } from './types';

const errorState = (payload) => ({
  type: SET_ERROR_STATE,
  payload,
});

export const setErrorState = (status) =>
  debounce((dispatch) => {
    dispatch(
      errorState({
        hasError: status,
      })
    );
  }, 1000);

export default {
  setErrorState,
};
